"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAVORITE_HEART_ROOT = void 0;
const FAVORITE_HEART_ROOT = exports.FAVORITE_HEART_ROOT = 'favorite-heart-root';
